import { render, staticRenderFns } from "./AddChatComment.vue?vue&type=template&id=f2e525ec&scoped=true&"
import script from "./AddChatComment.vue?vue&type=script&lang=js&"
export * from "./AddChatComment.vue?vue&type=script&lang=js&"
import style0 from "./AddChatComment.vue?vue&type=style&index=0&id=f2e525ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e525ec",
  null
  
)

export default component.exports